


















import { mapGetters, mapActions } from 'vuex'
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation } from '../store-helper'
import { IExam } from '../../../types'
import { qEditorState } from '../stores'
import { log } from 'util'

@Component({})
export default class ToolbarComponent extends Vue {
  notDisplay: boolean = false
  disableBtn: boolean = false
  get exam(){
    return qEditorState.exam
  }
  get hasError(){
    return qEditorState.hasError
  }
  get saveMessage(){
    return qEditorState.saveMessage
  }

  get isLoading() {
    return qEditorState.isLoading
  }

  onSave() {
    this.notDisplay = false
    this.disableBtn = true;
    qEditorState.saveQuestions()
  }

  @Watch('isLoading')
  hideMessage() {
    if (this.saveMessage) {
      setTimeout(() => {
        this.notDisplay = true;
        this.disableBtn = false;
    }, 3000);
    }
  }
}
